import { useState } from "react";

// FAQ component takes a title, subtitle, and an array of data in the shape of questions and answers, there is a default title so it is not neccessary unless you wish to change the title name from FAQ.

const FAQ = ({ title = "FAQ", subtitle, faqs = [] }) => {
  const [expandedFaq, setExpandedFaq] = useState(0);

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? -1 : index);
  };

  return (
    <section className="bg-blue py-12 md:py-16 lg:py-24 px-4 md:px-8 lg:px-16 xl:px-24 my-16 lg:my-24 xl:my-[160px]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8 lg:gap-16">
        <div className="md:w-1/3 flex flex-col justify-start text-center md:text-left">
          <img
            src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/white-horizontal-line.svg"
            alt=""
            className="w-14 lg:w-24 mb-4 mx-auto md:mx-0"
          />
          <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-8xl font-bold text-blue-navy mb-4">
            {title}
          </h2>
          {subtitle && (
            <p className="text-white !text-sm md:!text-base lg:!text-2xl xl:!text-4xl font-bold">
              {subtitle}
            </p>
          )}
        </div>

        <div className="md:w-2/3 flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white px-6 py-4 lg:px-8 lg:py-5 cursor-pointer ${expandedFaq === index ? "rounded-3xl" : "rounded-full"}`}
              onClick={() => toggleFaq(index)}
            >
              <div className="flex items-center justify-between">
                <h3 className="!text-sm lg:!text-xl font-bold pr-4 text-blue-navy">
                  {faq.question}
                </h3>
                <img
                  src={expandedFaq === index
                    ? "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/minus.svg"
                    : "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/plus.svg"
                  }
                  alt={expandedFaq === index ? "Collapse" : "Expand"}
                  className="w-5 h-5 lg:w-6 lg:h-6 min-w-[20px]"
                />
              </div>
              {expandedFaq === index && (
                <p className="!text-sm md:!text-base mt-3 leading-relaxed text-left">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
